import React from "react";
import { OrderedMap } from "immutable";
import { useParams } from "react-router-dom";
import useUserDateTime from "hooks/useUserDateTime";
import PaginatedEntityTable from "components/common/PaginatedEntityTable";
import QueryHelper from "components/common/QueryHelper";
import { useSearchSecurityEvents } from "security-app/hooks/useSecurityEventsAPI";
import { listElements } from "./constants";
import columnRenderers from "./column-renderers";
import RowActions from "./row-actions";
const humanName = "Investigation Events";
function InvestigationEventList({ eventIds = [], step = void 0 }) {
  const { userTimezone } = useUserDateTime();
  const { searchSecurityEvents, securityEventEntitiesKeyFn } = useSearchSecurityEvents(userTimezone);
  const { id: invId } = useParams();
  const investigationEventListFnKey = (searchParams) => {
    const securityEventsKey = securityEventEntitiesKeyFn(searchParams);
    securityEventsKey.push(invId);
    securityEventsKey.push(eventIds.join(","));
    return securityEventsKey;
  };
  const fetchInvestigationEvents = async (searchParams) => {
    const newFilters = OrderedMap({
      ...searchParams.filters || {},
      associated_investigations: [invId],
      event_ids: eventIds
    });
    const auxSearchParams = {
      ...searchParams,
      filters: newFilters
    };
    return searchSecurityEvents(auxSearchParams);
  };
  const renderActionsRow = (event) => /* @__PURE__ */ React.createElement(RowActions, { step, eventId: event.id });
  return /* @__PURE__ */ React.createElement(
    PaginatedEntityTable,
    {
      humanName,
      tableLayout: listElements.defaultLayout,
      queryHelpComponent: /* @__PURE__ */ React.createElement(QueryHelper, { entityName: humanName }),
      fetchEntities: fetchInvestigationEvents,
      keyFn: investigationEventListFnKey,
      entityAttributesAreCamelCase: false,
      columnRenderers,
      entityActions: step ? renderActionsRow : void 0,
      externalSearch: { query: "" },
      withoutURLParams: true,
      noPageSizeSelect: true,
      noColumnReordering: true
    }
  );
}
export default InvestigationEventList;
